module.exports = "/src/views/player/help/images/electric2.jpg";